<template>
    <div class="diabetesProgramSection pb-5">
        <div class="row justify-content-center p-3">
            <div class="col-12 col-xl-11  p-0">
                <div class="registerInner bg-white border-radius-5 ">
                    <loader v-if="pageLoader"></loader>
                    <message></message>
                    <div class="registerTitle text-center p-4">
                        <h2>Membership Plan</h2>
                        <p>Gini health combines specialized doctors knowledge with advanced technology to understand your health today and cover your future.</p>
                    </div>
                    
                    <div class="membershipPlan bg-white border-radius-5 ">
                        <div class="membership-Table">
                            <table class="table priceTable border mb-0">
                                <thead>
                                    <tr class="lightthemeBG">
                                        <th>&nbsp;</th>
                                        <th><span class="allVal">One time <span class="pValue">1,200</span></span></th>
                                        <th><span class="allVal">Diabetes Reversal Program <span class="pValue">6,000</span></span></th>
                                        <th><span class="allVal">Intensive Diabetes Management Program <span class="pValue">6,000</span></span></th>
                                        <th><span class="allVal">Membership <span class="pValue">5000</span></span></th>
                                        <th><span class="allVal">Diabetes Reversal Program with Testing <span class="pValue">12,000</span></span></th>
                                        <th><span class="allVal">Diabetes Management Program with Testing <span class="pValue">10,000</span></span></th>
                                        <th><span class="allVal">Primary Care Membership <span class="pValue">6,000</span></span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left">Visit with Doctor</td>
                                        <td align="center">1</td>
                                        <td align="center">6</td>
                                        <td align="center">6</td>
                                        <td align="center">5</td>
                                        <td align="center">4</td>
                                        <td align="center">4</td>
                                        <td align="center">4</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">Family and friends Doctor visit</td>
                                        <td align="center">0</td>
                                        <td align="center">2</td>
                                        <td align="center">2</td>
                                        <td align="center">-</td>
                                        <td align="center">2</td>
                                        <td align="center">2</td>
                                        <td align="center">2</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">Dietitian Consultation</td>
                                        <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                        <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Weekly/Monthly</span></td>
                                        <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Weekly/Monthly</span></td>
                                        <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                        <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Weekly/Monthly</span></td>
                                        <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Weekly/Monthly</span></td>
                                        <td align="center">4</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">Family and friends Dietitian visit</td>
                                        <td align="center">-</td>
                                        <td align="center">-</td>
                                        <td align="center">-</td>
                                        <td align="center">-</td>
                                        <td align="center">-</td>
                                        <td align="center">-</td>
                                        <td align="center">-</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">Testing</td>
                                        <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                        <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                        <td align="center"><span class="checkCircle x"><feather type="x"></feather> </span></td>
                                        <td align="center">-</td>
                                        <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Quarterly</span></td>
                                        <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Quarterly</span></td>
                                        <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Quarterly HBA1C</span></td>
                                    </tr>
                                    
                                    
                                    <tr class="strButton">
                                        <td class="text-left">&nbsp;</td>
                                        <td align="center"><a href="javascript:void(0)" class="grid_btn" @click.prevent="selected_plan = 1;register()"><span>Select Plan</span></a></td>
                                        <td align="center"><a href="javascript:void(0)" class="grid_btn" @click.prevent="selected_plan = 2;register()"><span>Select Plan</span></a></td>
                                        <td align="center"><a href="javascript:void(0)" class="grid_btn" @click.prevent="selected_plan = 3;register()"><span>Select Plan</span></a></td>
                                        <td align="center"><a href="javascript:void(0)" class="grid_btn" @click.prevent="selected_plan = 4;register()"><span>Select Plan</span></a></td>
                                        <td align="center"><a href="javascript:void(0)" class="grid_btn" @click.prevent="selected_plan = 5;register()"><span>Select Plan</span></a></td>
                                        <td align="center"><a href="javascript:void(0)" class="grid_btn" @click.prevent="selected_plan = 6;register()"><span>Select Plan</span></a></td>
                                        <td align="center"><a href="javascript:void(0)" class="grid_btn" @click.prevent="selected_plan = 7;register()"><span>Select Plan</span></a></td>
                                    </tr>
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                
                <div class="seeMoreButton mt-3 ">
                    <table class="table mb-0">
                        <tr>
                            <td  align="center" colspan="0" class="border-0 p-0"><button class=" showMore border-btn dark w-100 d-flex align-items-center justify-content-center" @click="showMore = !showMore"><span>{{showMore?'Hide detailed plan Comparison':'Show detailed plan Comparison'}} </span><feather class="ml-2" :type="(showMore)?'chevron-up':'chevron-down'"></feather></button></td>
                        </tr>
                    </table>
                </div>
               
                <div class="membershipPlan mt-3 registerInner bg-white border-radius-5" v-show="showMore">
                    <div class="membership-Table">
                        <table class="table priceTable border mb-0">         
                            <tbody>
                                <tr v-show="showMore">
                                    <td class="text-left">Medical History </td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                </tr>
                                <tr v-show="showMore">
                                    <td class="text-left">Exercise Coaching</td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span></td>
                                    <td align="center">4</td>
                                </tr>
                                <tr v-show="showMore">
                                    <td class="text-left">Care Co-ordinators Check in</td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Weekly/Monthly</span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Weekly/Monthly</span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Weekly/Monthly</span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Weekly/Monthly</span></td>
                                    <td align="center"><span class="checkCircle"><feather type="check"></feather></span> <span class="wm">Monthly</span></td>
                                    <td align="center">4</td>
                                </tr>
                                <tr v-show="showMore">
                                    <td class="text-left">Discount on Lab Testing</td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                    <td align="center">10%</td>
                                    <td align="center">10%</td>
                                    <td align="center">10%</td>
                                    <td align="center">10%</td>
                                    <td align="center">10%</td>
                                    <td align="center">10%</td>
                                </tr>
                                <tr v-show="showMore">
                                    <td class="text-left">Discount on Medicine</td>
                                    <td align="center">10%</td>
                                    <td align="center">15%</td>
                                    <td align="center">15%</td>
                                    <td align="center">15%</td>
                                    <td align="center">15%</td>
                                    <td align="center">15%</td>
                                    <td align="center">15%</td>
                                </tr>
                                <tr v-show="showMore">
                                    <td class="text-left">Mobile App</td>
                                    <td align="center">Free</td>
                                    <td align="center">Free</td>
                                    <td align="center">Free</td>
                                    <td align="center">Free</td>
                                    <td align="center">Free</td>
                                    <td align="center">Free</td>
                                    <td align="center">Free</td>
                                </tr>
                                <tr v-show="showMore">
                                    <td class="text-left">Installments</td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                    <td align="center">-</td>
                                    <td align="center">5000, 1000, 3000, 3000</td>
                                    <td align="center">5000, 1000, 2000, 2000</td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                </tr>
                                <tr v-show="showMore">
                                    <td class="text-left">Discount If paid annual</td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                    <td align="center">-</td>
                                    <td align="center">10%</td>
                                    <td align="center">10%</td>
                                    <td align="center"><span class="checkCircle x"><feather type="x"></feather></span></td>
                                </tr>
                                
                                
                                
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "membership-plan",
        data() {
            return {
                details:false,
                checkTest:true,
                showMore: false,
            }
        },
        created(){
            this.pageName('Membership Plan')
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/website/membership_plan/list.vue